import { type GetDisputeCasesVariables } from '@repo/internal-tools-api/src/services/cases/DisputeCasesService.ts'
import type { TabOption } from '@repo/internal-tools-design-system/src/lib/Tabs/Tabs.tsx'
import type {
  EnumKey,
  ObjVal,
} from '@repo/internal-tools-type-utils/src/utils.ts'
import type { PaginationState } from '@tanstack/react-table'

export const INITIAL_CASE_TABLE_PAGINATION_STATE = {
  pageIndex: 0,
  pageSize: 25,
} satisfies PaginationState

export type CaseFilterType = NonNullable<GetDisputeCasesVariables>['filterType']

export const CASE_TABLE_TILE_TABS = {
  ALL: 'All',
  OPEN_CASES: 'OpenCases',
  ASSIGNED_TO_ME: 'AssignedToMe',
  UNASSIGNED: 'UnAssigned',
  PASSED_DUE_DATE: 'PassedDueDate',
  DUE_IN_7_DAYS: 'DueIn7Days',
} satisfies Record<EnumKey, CaseFilterType>

export type CaseTableTileTabs = typeof CASE_TABLE_TILE_TABS
export type CaseTableTileTab = ObjVal<CaseTableTileTabs>

export const DEFAULT_CASE_TABLE_TILE_TAB = CASE_TABLE_TILE_TABS.OPEN_CASES

export const CASE_TABLE_TILE_TAB_OPTIONS = [
  { id: CASE_TABLE_TILE_TABS.OPEN_CASES, label: 'Open cases' },
  { id: CASE_TABLE_TILE_TABS.ASSIGNED_TO_ME, label: 'My cases' },
  { id: CASE_TABLE_TILE_TABS.UNASSIGNED, label: 'Unassigned' },
  { id: CASE_TABLE_TILE_TABS.PASSED_DUE_DATE, label: 'Past due' },
  { id: CASE_TABLE_TILE_TABS.DUE_IN_7_DAYS, label: 'Due within 7 days' },
  { id: CASE_TABLE_TILE_TABS.ALL, label: 'All' },
] as const satisfies TabOption<CaseTableTileTab>[]
